module.exports = __webpack_public_path__ + "img/layout_fish_left.9f68371d.svg";